import { Component } from '@angular/core';

@Component({
  selector: 'app-tenant-selection-route',
  standalone: true,
  template: '',
})
export class TenantSelectionRouteComponent {}
